import React from 'react';
import Sidebar from './Sidebar';

interface Props {
  children: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
}

export default function Layout({ children, title, actions }: Props) {
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top bar */}
        <header className="h-12 flex-shrink-0 flex items-center justify-between px-5 border-b border-gray-200 bg-white shadow-sm">
          <div className="flex items-center gap-2 min-w-0">
            <div className="w-1.5 h-5 rounded-full flex-shrink-0" style={{background:'linear-gradient(180deg,#02357A,#039089)'}}/>
            {title ? (
              <span className="text-sm font-semibold text-gray-700 truncate">{title}</span>
            ) : (
              <span className="text-sm text-gray-400">Clinqov Meditrack HIS</span>
            )}
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            {actions && <div className="flex items-center gap-2">{actions}</div>}
            <div className="w-px h-4 bg-gray-200"/>
            <span className="text-xs text-gray-400 hidden sm:block">
              {new Date().toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short',year:'numeric'})}
            </span>
            <div className="w-px h-4 bg-gray-200"/>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"/>
              <span className="text-xs text-gray-500">Online</span>
            </div>
          </div>
        </header>
        {/* Page content */}
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
